import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const AdvancedTypewriter = ({
  text,
  speed = 50,
  delay = 0,
  deleteSpeed = 30,
  loop = false,
  loopDelay = 2000,
  onComplete,
  cursor = true,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    let timeout;

    if (!isCompleted || loop) {
      if (isDeleting) {
        // Deleting text
        if (displayedText.length > 0) {
          timeout = setTimeout(() => {
            setDisplayedText((prev) => prev.slice(0, -1));
          }, deleteSpeed);
        } else {
          setIsDeleting(false);
          setCurrentIndex(0);
          if (!loop) setIsCompleted(true);
          timeout = setTimeout(() => {}, loopDelay);
        }
      } else {
        // Typing text
        if (currentIndex < text.length) {
          timeout = setTimeout(() => {
            setDisplayedText((prev) => prev + text[currentIndex]);
            setCurrentIndex((prev) => prev + 1);
          }, speed);
        } else {
          if (loop) {
            timeout = setTimeout(() => {
              setIsDeleting(true);
            }, loopDelay);
          } else {
            setIsCompleted(true);
            if (onComplete) onComplete();
          }
        }
      }
    }

    return () => clearTimeout(timeout);
  }, [
    currentIndex,
    text,
    speed,
    deleteSpeed,
    isDeleting,
    displayedText,
    loop,
    loopDelay,
    isCompleted,
    onComplete,
  ]);

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: delay }}
    >
      {displayedText}
      {cursor && (
        <motion.span
          animate={{ opacity: [0, 1, 0] }}
          transition={{
            repeat: Infinity,
            duration: 0.8,
            repeatDelay: 0,
          }}
        >
          |
        </motion.span>
      )}
    </motion.span>
  );
};

export default AdvancedTypewriter;